import { FunctionComponent, useCallback, useEffect, useState } from "react";
import useQueryFetch from "../../../modules/api/apiHooks/useQueryFetch";
import { getAtkHeader } from "../../../modules/api/fetch/getHeaders";
import { AUTO_SUGGEST, SEARCH } from "../../../modules/graphql/searchGraphQL";
import { useSearchResultMutator } from "../../../modules/search/searchContext/searchContextHooks";
import { keyboardLayouts, mergeSearchQueriesResult } from "../../../modules/search/searchService";
import { FocusContext, setFocus, useFocusable } from "../../../modules/spatialNavigation";
import FocusableButton from "../../shared/focusableButton/FocusableButton";
import * as styles from "./styles.module.scss";
interface IProps {}
const VirtualKeyboard: FunctionComponent<IProps> = () => {
  const [layoutName, setLayoutName] = useState<"english" | "default">("default");
  const [searchQuery, setSearchQuery] = useState("");

  const dispatchSearchResult = useSearchResultMutator();

  // queryFetch
  const [search, searchContext] = useQueryFetch(process.env.TV_API_BASE_URL!, SEARCH, getAtkHeader);
  const [autoSuggest, autoSuggestContext] = useQueryFetch(process.env.TV_API_BASE_URL!, AUTO_SUGGEST, getAtkHeader);

  // keypad events
  const onLetterPress = useCallback((letter) => {
    setSearchQuery((prevText) => prevText + letter);
  }, []);
  const onPressBackSpace = () => {
    setSearchQuery((prevText) => prevText.slice(0, -1));
  };
  const onPressSpace = () => {
    setSearchQuery((prevText) => prevText + " ");
  };
  const onClickingSearch = async () => {
    dispatchSearchResult({ loading: true });
    const searchData = await search({ query: searchQuery, page: 1 });
    const autoSuggestData = await autoSuggest({ text: searchQuery });
    const mergedResult = mergeSearchQueriesResult(autoSuggestData.data.autoSuggest.data, searchData.data.search.data);
    dispatchSearchResult({ ...mergedResult, loading: false });
  };
  useEffect(() => {
    if (autoSuggestContext.error || searchContext.error) {
      dispatchSearchResult({ loading: false });
    }
  }, [autoSuggestContext.error, searchContext.error]);
  // effects
  useEffect(() => {
    setFocus("key-item-alphabet-0");
  }, []);

  const { ref, focusKey } = useFocusable({
    trackChildren: true,
    isFocusBoundary: true,
    autoRestoreFocus: true,
    focusBoundaryDirections: ["up", "down"],
  });

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles.keyboardContainer}>
        <div className={styles.container}>
          <div style={{ direction: layoutName === "english" ? "ltr" : "rtl" }} className={styles.searchQuery}>
            {searchQuery}
          </div>
          <div className={styles.letters} style={{ direction: layoutName === "default" ? "rtl" : "ltr" }}>
            {keyboardLayouts[layoutName].alphabet.map((key, index) => (
              <FocusableButton
                isCentered
                key={"btn-letter-" + index}
                label={key}
                focusKey={"key-item-alphabet-" + index}
                onClick={() => onLetterPress(key)}
              />
            ))}
          </div>
          <div className={styles.letters} style={{ direction: layoutName === "default" ? "rtl" : "ltr" }}>
            {keyboardLayouts[layoutName].number.map((key, index) => (
              <FocusableButton
                isCentered
                key={"btn-number-" + index}
                label={key}
                focusKey={"key-item-number-" + index}
                onClick={() => onLetterPress(key)}
              />
            ))}
          </div>
          <div className={styles.row}>
            <FocusableButton isCentered focusKey="backspace" label="" startIcon="&#xe14a;" onClick={onPressBackSpace} />
            <FocusableButton isCentered focusKey="space" label="" startIcon="&#xe256;" onClick={onPressSpace} />
            <FocusableButton
              isCentered
              focusKey="lang"
              label=""
              startIcon="&#xe894;"
              onClick={() => {
                setLayoutName((prevLayout) => (prevLayout === "default" ? "english" : "default"));
              }}
            />
            <div className={styles.removeAllBtn}>
              <FocusableButton
                isCentered
                focusKey="remove"
                label="پاک کردن"
                startIcon=""
                onClick={() => {
                  setSearchQuery("");
                  dispatchSearchResult({ loading: false, items: null, artists: null, tags: null });
                }}
              />
            </div>
          </div>
          <div className={styles.searchBtn}>
            <FocusableButton
              isCentered
              active
              focusKey="search"
              label="جستجو"
              startIcon="&#xe8b6;"
              onClick={onClickingSearch}
            />
          </div>
        </div>
      </div>
    </FocusContext.Provider>
  );
};
export default VirtualKeyboard;
